export interface IPOSTableDetailsFormSchema {
  transNo: string;
  guestName: string;
  nationality: string;
  totalPax: string;
  serviceType: string;
  guestType: string;
  remarks: string;

  // Tax Payer Information (Optional)
  guestAccountRefID: string;
  busName: string;
  taxTIN: string;
  busType: string;
  homeAddress: string;
  province: string | null;
  countryCode: string | null;
  expenseType: string;
  vatType: string;
  serviceCharge: boolean;
  serviceChargeRate: string;
}

export const defaultValues: IPOSTableDetailsFormSchema = {
  transNo: '',
  guestName: '',
  nationality: 'PHL',
  totalPax: '1',
  serviceType: 'Dine-In',
  guestType: 'In-House',
  remarks: '',

  // Tax Payer Information (Optional)
  guestAccountRefID: '',
  busName: '',
  taxTIN: '',
  busType: '',
  homeAddress: '',
  province: '',
  countryCode: '',
  expenseType: '',
  vatType: 'VATable',
  serviceCharge: true,
  serviceChargeRate: '0',
};

export interface IPOSProfileInfo {
  guestAccountRefID: string;
  caption: string;
  taxTIN: string;
  taxBusStyle: string;
  address: string;
  province: string;
  country: string;
  contact: string;
  email: string;
  accountType: string;
  clearGuestAccount: boolean;
}

export interface CreateTransactionPayload {
  properties: Array<{
    property: {
      propertyID: string;
      posTransactions: Array<{
        posTransaction: {
          stationID: string;
          tableID: string;
          defaultServiceChargePercentage: string | null;
          defaultLocalTaxPercentage: string | null;
          defaultVatType: string | null;
          modifyServiceChargePercentage: number;
          modifyLocalTaxPercentage: string | null;
          modifyVatType: string | null;
          totalPax: number;
          serviceOptionID: number;
          alternateGuestName: string | null;
          guestAccountRefID: string;
          nationalityID: number;
          remarksNote: string;
          representationExpenseID: string | null;
          profileInfo?: IPOSProfileInfo | null;

          signature: string;
        };
      }>;
    };
  }>;
}

export interface UpdateTransactionPayload {
  properties: Array<{
    property: {
      propertyID: string;
      posTransactions: Array<{
        posTransaction: {
          stationID: string;
          tableID: string;
          modifyServiceChargePercentage: number;
          modifyLocalTaxPercentage: string | null;
          modifyVatType: string | null;
          totalPax: number;
          serviceOptionID: number;
          alternateGuestName: string | null;
          nationalityID: number;
          remarksNote: string;
          representationExpenseID: string | null;
          profileInfo?: IPOSProfileInfo | null;

          signature: string;
        };
      }>;
    };
  }>;
}

export interface DeleteTransactionPayload {
  properties: Array<{
    property: {
      propertyID: string;
      voidInvoices: Array<{
        voidInvoice: {
          reason: string;
          approvedBy: string;
          signature: string;
        };
      }>;
      signature: string;
    };
  }>;
}

export interface IResDeleteTransactionPayload {
  results: {
    responseCode: number;
    responseMessage: string;
  };
}

export interface ChargeToRoomTransactionPayload {
  properties: Array<{
    property: {
      propertyID: string;
      shiftID: string;
      stationID: string;
      bookingID: string;
      signature: string;
    };
  }>;
}
